import { useState, useEffect } from 'react'
import { get } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import FormLoader from '../../../../components/loader/FormLoader'
import { Icon } from '@iconify/react'
import CreateAdmin from './CreateAdmin'
import Pagination from '../../../../components/pagination/Pagination'
import { useNavigate } from 'react-router-dom'

function Admins() {
  const { notify, profile } = useGlobalContext()
  const [admins, setAdmins] = useState<any>({ data: [] })
  const [loading, setLoading] = useState(true)
  const [showCreateAdmin, setShowCreateAdmin] = useState(false)
  const [search, setSearch] = useState('')
  const navigate = useNavigate()

  function fetchAdmins(page: number, pageSize: number) {
    setLoading(true)
    let url = ''
    if (search) {
      url = `admin/?search=${search}&page=${page}&limit=${pageSize}`
    } else {
      url = `admin/?page=${page}&limit=${pageSize}`
    }
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setAdmins(result.data)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  useEffect(() => {
    fetchAdmins(1, 10)
  }, [])

  return (
    <div className='home'>
      {showCreateAdmin && (
        <CreateAdmin
          setShowCreateAdmin={setShowCreateAdmin}
          fetchAdmins={fetchAdmins}
        />
      )}
      <div className='home_tag flex justify-between'>
        <span></span>
        {profile.role === 'super admin' && (
          <button onClick={() => setShowCreateAdmin(true)}>Create Admin</button>
        )}
      </div>
      <div className='home_tables'>
        <div className='left'>
          <div className='flex justify-between items-center search-btns flex-wrap'>
            <div className='search flex'>
              <input
                type='search'
                name=''
                id=''
                value={search}
                placeholder='search by name or email'
                onChange={(e) => {
                  setSearch(e.target.value)
                }}
              />{' '}
              <button
                onClick={() => {
                  fetchAdmins(1, 10)
                }}
              >
                Search
              </button>
            </div>
          </div>
          {loading ? (
            <FormLoader position='center' />
          ) : (
            <>
              {admins.docs.length > 0 ? (
                <>
                  <div className='mobile-table'>
                    {admins.docs.map((item: any, i: number) => (
                      <div
                        className='card'
                        onClick={() => navigate(`/admin/admin/${item._id}`)}
                        key={item._id}
                      >
                        <div className='flex justify-between row'>
                          <div className='count flex items-center justify-center'>
                            {i + 1}
                          </div>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Name</h4>
                          <p>{item.name}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Role</h4>
                          <p>{item.role}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Email</h4>
                          <p>{item.email}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Phone</h4>
                          <p>{item.phone}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Status</h4>
                          <p>{item.status}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <table className='desktop-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Location</th>
                        <th>Phone</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {admins.docs.map((item: any, i: number) => (
                        <tr key={item._id}>
                          <td>{i + 1}</td>
                          <td className='count'>{item.name}</td>
                          <td className='count'>{item.role}</td>
                          <td>{item.location}</td>
                          <td>{item.phone}</td>
                          <td>
                            {item.status === 'inactive' ? (
                              <span className='CCD'>Inactive</span>
                            ) : (
                              <span className='OK'>Active</span>
                            )}
                          </td>
                          <td>
                            <span
                              className='view'
                              onClick={() =>
                                navigate(`/admin/admin/${item._id}`)
                              }
                            >
                              view
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={admins.page}
                    totalCount={admins.totalPages}
                    pageSize={admins.limit}
                    onPageChange={(page: number, pageSize: number) => {
                      fetchAdmins(page, pageSize)
                    }}
                  />
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='fa6-solid:users-gear' />
                    <h1>No Admins To Show</h1>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Admins
